import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import DisplaySkill from "./DisplaySkill";
import { project_skills } from "./utils/data";

const Project = ({ project }) => {
  return (
    <div className="grid grid-rows-2 border-2 border-slate-50 p-10 h-[1275px] sm:h-[1000px] shadow-[0_20px_50px_rgba(8,_112,_184,_0.7)] rounded-xl mt-[30px]">
      <div className="flex flex-col items-center">
        <div className="flex flex-row mb-[25px] items-center">
          <h2 className="font-semibold text-[30px] text-white mr-[10px]">
            {project.name}
          </h2>
          <a href={project.url} target="_blank" rel="noreferrer">
            <FontAwesomeIcon
              icon={faArrowUpRightFromSquare}
              className="text-white h-[20px] w-[20px] hover:scale-105 duration-300 mt-2"
            />
          </a>
        </div>
        <img src={require(`./assets/${project.name}.png`)} alt={project.name} />
        <div className="flex flex-col">
          <hr className="w-48 h-1 mx-auto my-4 bg-gray-100 border-0 rounded md:my-10 dark:bg-gray-700 hover:w-60 duration-300" />
          <div className="flex justify-center flex-wrap">
            {project_skills.map((skill, index) => (
              <DisplaySkill skill={skill} key={index} />
            ))}
          </div>
          <hr className="w-48 h-1 mx-auto my-4 bg-gray-100 border-0 rounded md:my-10 dark:bg-gray-700 hover:w-60 duration-300" />
          <div className="text-[20px] list-none text-teal-100 font-Poppins italic leading-10">
            {project.description}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Project;
